import { RadioGroupItem } from "components/DesignSystem/RadioGroup/RadioGroup";
import { ComponentProps, ReactNode } from "react";

export const RadioCard = ({
  value,
  children,
  ...props
}: {
  value: string;
  children: ReactNode;
} & ComponentProps<typeof RadioGroupItem>) => (
  <label
    htmlFor={value}
    className="t-flex t-gap-1.5 t-items-start t-cursor-pointer"
  >
    <div className="t-flex t-mt-0.5">
      <RadioGroupItem {...props} value={value} id={value} />
    </div>
    {children}
  </label>
);
